export default "__VITE_ASSET__DM_ik3ve__"